import { InventoryScreen } from '@/features/inventory/components/inventory-screen';

export function InventoryPage() {
  return <InventoryScreen />;
}
